import $ from "jquery";
window.$ = window.jquery = $;

import React, { useEffect, useState, } from "react";
import Base from '../utils/base'

import Slider from './components/Slider'
import About from './components/About'
import Benefit from './components/Benefit'
import Feature from './components/Feature'
import Blog from './components/Blog'
import Carousel from './components/Carousel'
import Review from './components/Review'
import Promotion from './components/Promotion'
import Tour from './components/Tour'
import Gallery from './components/Gallery'

export default function Home(props) {
	var base = new Base()

  

  return (
    <>
      <Slider/>
      <About/>
      {/* <Feature/> */}
      {/* <Benefit/> */}
      {/* <Review/> */}
      <Promotion/>
      {/* <Tour/> */}
      <Gallery/>
      <Blog/>
      {/* <Carousel/> */}
    </>
  );
};
